import { defineCustomElement } from 'ionicons/components/ion-icon.js';

/**
 * Registers the Ionicons <ion-icon> web component, once, from the npm package.
 *
 * Ionicons' own instructions for use outside Ionic load it from a CDN at
 * runtime; installing it from npm instead means no third-party request on
 * page load, and the icons are bundled into the build.
 */
defineCustomElement();

interface IconProps {
  /**
   * Icon data imported from 'ionicons/icons', e.g.
   * `import { mailOutline } from 'ionicons/icons'`. Only the icons that are
   * imported somewhere end up in the bundle.
   */
  icon: string;
  /**
   * Size and colour. Include a size class (e.g. `size-6`) whenever you pass
   * this, since it replaces the default rather than adding to it. The icon
   * takes the current text colour.
   */
  className?: string;
  /**
   * Only for icons that carry meaning on their own, with no visible text
   * beside them. Omit it for the usual case of an icon next to a label, and
   * the icon is hidden from screen readers so the label isn't read twice.
   */
  label?: string;
}

export function Icon({ icon, className = 'size-5', label }: IconProps) {
  return (
    <ion-icon
      icon={icon}
      className={`shrink-0 ${className}`}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
